<template>
    <q-banner class="text-center q-pa-md" :class="state.classes">
        <div v-if="title" class="text-h5 q-mb-sm">
            <q-icon :name="state.icon" class="on-left" />
            {{ title }}
        </div>
        <div class="flex items-center justify-center">
            <slot />
        </div>
    </q-banner>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    title: String,
    icon: String, // override the default icon
    variant: String, // positive, info, warning, negative
})

const state = computed(() => {
    switch (props.variant) {
        case 'positive': return {
            classes: 'bg-green-5 text-white',
            icon: props.icon || 'done',
        }

        case 'info': return {
            classes: 'bg-blue-8 text-white',
            icon: props.icon || 'error_outline',
        }

        default: return {
            classes: 'bg-soft-primary',
            icon: props.icon || 'warning',
        }
    }
})
</script>
